import { HTTP_METHODS } from '@studio/constants/axios';
import { ONBOARDING_API_V1 } from '@studio/constants/env-variables';
import type { Onboarding } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    response: {} as Onboarding.Get.CustomerTrialResponse,
    url: `${ONBOARDING_API_V1}/customers/@customerId/trials`,
  },
};

export const id = {};
